import { render } from "./module.vue?vue&type=template&id=320029ea"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/evox/brands/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "320029ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('320029ea', __exports__)) {
    api.reload('320029ea', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=320029ea", () => {
    api.rerender('320029ea', render)
  })

}


export default __exports__